import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/button';
import { EmptyStateCardBody } from '../../../components/EmptyStateCard';

type Props = {
  message: string;
  onClear: () => void;
};

export const CategoryFilterEmptyState: React.FC<
  React.PropsWithChildren<Props>
> = ({ message, onClear }) => {
  const { t } = useTranslation();
  return (
    <EmptyStateCardBody
      title={message}
      subtitle={t('skills.employeeSkills.filteredEmptySubtitle')}
      action={
        <Button
          label={t('skills.matrix.clearCategoryFilter')}
          size="sm"
          variant="link"
          onClick={onClear}
        />
      }
    />
  );
};
